import React, { FC, useState } from "react";
import InDetailView from "../templates/InDetailView";
import PhaseFieldDetailsUpdate from "./PhaseFieldDetailsUpdate";
import ActivityListView from "../activity/ActivityListView";
import DocumentsTabWrapper from "../projectDocument/DocumentsTabWrapper";
import PhaseStatusTimeLine from "./PhaseStatusTimeLine";
import PhaseActivityStreamLine from "./PhaseActivityStreamLine";

const PhaseInDetailView: FC<{
  activeTab: string;
}> = ({ activeTab }) => {
  const [tab, setTab] = useState(activeTab);
  const [hideTabTitles, setHideTabTitles] = useState(false);
  const [refresh, setRefresh] = React.useState(false);

  return (
    <InDetailView
      body={{
        refreshOptions: {
          enabled: true,
          refresh: refresh,
          onRefresh: setRefresh,
        },
        hideTabTitles: hideTabTitles,
        tabOptions: {
          tab: tab,
          setTab: setTab,
          tabs: [
            {
              label: "Activities",
              tabKey: "activities",
              content: (
                <ActivityListView
                  setHideTabTitles={setHideTabTitles}
                  currentTab={tab}
                />
              ),
            },
            {
              label: "Documents",
              tabKey: "documents",
              content: <DocumentsTabWrapper linkType="phase" />,
            },
            {
              label: "View",
              tabKey: "view",
              content: <PhaseFieldDetailsUpdate />,
            },
            {
              label: "Status Timeline",
              tabKey: "timeline",
              content: <PhaseStatusTimeLine />,
            },
            {
              label: "Activity Stream",
              tabKey: "activityStream",
              content: <PhaseActivityStreamLine activeTab={tab} />, 
            },
          ],
        },
      }}
    />
  );
};

export default PhaseInDetailView;